// Schema.org JSON-LD builders. Plain ESM with no imports so both the React
// app and the Node prerender script (scripts/prerender.mjs) can share it.

export function organizationSchema(site) {
  return {
    '@context': 'https://schema.org',
    '@type': ['EducationalOrganization', 'Organization'],
    '@id': `${site.url}/#organization`,
    name: site.name,
    alternateName: 'Muller Music School',
    url: site.url,
    logo: { '@type': 'ImageObject', url: site.logo, width: 512, height: 512 },
    image: site.ogImage,
    email: site.email,
    telephone: site.phone,
    address: {
      '@type': 'PostalAddress',
      addressLocality: site.city,
      addressRegion: site.region,
      addressCountry: site.country,
    },
    areaServed: 'Worldwide',
    contactPoint: [{
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: site.email,
      telephone: site.phone,
      availableLanguage: ['English', 'Amharic'],
    }],
    ...(site.social && site.social.length ? { sameAs: site.social } : {}),
  };
}

export function websiteSchema(site) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${site.url}/#website`,
    url: site.url,
    name: site.name,
    publisher: { '@id': `${site.url}/#organization` },
    inLanguage: 'en',
  };
}

export function faqSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map(({ q, a }) => ({
      '@type': 'Question',
      name: q,
      acceptedAnswer: { '@type': 'Answer', text: a },
    })),
  };
}

export function webPageSchema(site, path, route) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    url: `${site.url}${path === '/' ? '/' : path}`,
    name: route.title,
    description: route.description,
    isPartOf: { '@id': `${site.url}/#website` },
    about: { '@id': `${site.url}/#organization` },
    inLanguage: 'en',
  };
}
